import { SectionComponents } from '~/types/components'

export default function () {
  const resolveSectionComponent = (block: SectionComponents) => {
    if (!block) {
      return
    }

    const componentName = Object.entries(SectionComponents).find(([key, _]) => key === block)?.[1]

    if (!componentName) {
      console.error(`Component for model type [${block}] does not exist.`)
    } else {
      return resolveComponent(componentName)
    }
  }

  return {
    resolveSectionComponent
  }
}
